import { AlertTriangle, ArrowRight, RefreshCw } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function ErrorState({
  title = "حدث خطأ",
  message = "لم نتمكن من تحميل هذه الصفحة.",
  onRetry,
  onBack,
}) {
  return (
    <div className="flex items-center justify-center min-h-[60vh] p-6" dir="rtl">
      <div className="max-w-sm w-full text-center space-y-5">
        <div className="w-14 h-14 rounded-full bg-destructive/10 flex items-center justify-center mx-auto">
          <AlertTriangle className="w-7 h-7 text-destructive" />
        </div>
        <div className="space-y-2">
          <h2 className="text-lg font-semibold text-foreground">{title}</h2>
          <p className="text-sm text-muted-foreground leading-relaxed">{message}</p>
        </div>
        <div className="flex items-center justify-center gap-3">
          {onBack && (
            <Button variant="outline" size="sm" onClick={onBack} className="gap-1.5">
              <ArrowRight className="w-4 h-4" />
              رجوع
            </Button>
          )}
          {onRetry && (
            <Button size="sm" onClick={onRetry} className="gap-1.5 bg-brand hover:bg-brand/90 text-brand-foreground">
              <RefreshCw className="w-4 h-4" />
              إعادة المحاولة
            </Button>
          )}
        </div>
      </div>
    </div>
  );
}
